import { isRequired, cleanString } from '../../utils.js';

var unit = (_ref => {
  let {
    unit_name = isRequired('unit_name'),
    unit_type = isRequired('unit_type')
  } = _ref;
  return () => ({
    unit_type,
    unit_name: cleanString(unit_name)
  });
});

export default unit;
